import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useState} from 'react'
import { motion, AnimatePresence } from "framer-motion";
import {darkModeState} from '../../../atoms/darkModeState'
import { globalSelectedOrganization } from '../../../atoms/orgStates';
import { useRecoilState, useRecoilValue } from "recoil";

function SshInstanceModal({instance, btnType}) {
    const selectedOrganization = useRecoilValue(globalSelectedOrganization);
    const isDark = useRecoilValue(darkModeState);
    let [isOpen, setIsOpen] = useState(false)

    function closeModal() {
        setIsOpen(false)
      }
    
      function openModal() {
        setIsOpen(true)
      }

  return (
    <>
      <div className="flex items-center justify-end">
      {btnType ==='standardBtn' &&
        <button
            disabled={!instance.cloud_server_is_ready} 
            className={`relative px-4 w-full py-0.5 border-[0.01em] rounded-xl ${isDark?'border-blue-400':'border-blue-500'} mx-2 hover:bg-blue-500/10 max-w-[100px]`} 
            onClick={openModal}
        >
            <span className={`${isDark?'text-blue-300':'text-blue-500'} text-sm`}>SSH</span>
            {!instance.cloud_server_is_ready && 
            <div >
                <svg aria-hidden="true" className={`absolute top-1/4 right-1/3 ml-8 w-5 h-15 animate-spin dark:fill-white dark:text-gray-500 fill-blue-600 text-gray-300`} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path>
                </svg>
            </div>
            }
        </button>
        }
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center ">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className={`w-full md:w-[80%] mx-4 transform overflow-hidden rounded-2xl text-left align-middle shadow-xl transition-all ${isDark?'bg-slate-800':'bg-white'}`}>
                    <div className={`mb-1 p-4 text-lg font-medium leading-6 border-b-[1px] ${isDark?'text-gray-100 border-gray-700':'text-gray-700 border-gray-200'}`}>
                        Access cloud server remotely via SSH
                    </div>
                  <AnimatePresence mode='wait'>
                      <motion.div
                        key='selectCloudServerTypeDiv'
                        initial={{ y: 10, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -10, opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        >
                          <div className='flex flex-col px-4 mt-4 space-y-2'>
                            <div className={`font-bold ${isDark?'text-gray-400':'text-gray-600'}`}>
                                1. Open an SSH client or command line shell
                            </div>
                            <div className={`font-normal ${isDark?'text-gray-300':'text-gray-600'}`}>
                                You can use the regular terminal in MacOS or Linux. For Windows use PowerShell.
                            </div>
                            <div className={`font-bold ${isDark?'text-gray-400':'text-gray-600'}`}>
                                2. Ensure your private key is not isn't publicly viewable
                            </div>
                            <div className={`font-normal ${isDark?'text-gray-300':'text-gray-600'}`}>
                                Using your command line shell or terminal navigate the directory where your private key is located. Use chmod to ensure your key is not publicly viewable  
                            </div>
                            <div className={`font-normal ${isDark?'text-rose-300':'text-rose-400'}`}>
                                <code >chmod 400 <span className={`${isDark?'text-blue-300':'text-blue-400'}`}>[private key name for that server]</span>.pem </code>&nbsp; 
                            </div>
                            <div className={`font-bold ${isDark?'text-gray-400':'text-gray-600'}`}>
                                3. Connect to your cloud server using its Public DNS:
                            </div>
                            <div className={`font-normal ${isDark?'text-rose-300':'text-rose-400'}`}>
                                <code id="publicDns">ssh -i <span className={`${isDark?'text-blue-300':'text-blue-400'}`}>[private key name for that server]</span>.pem ubuntu@{instance.cloud_server_dns_record_name}</code>&nbsp;
                            </div>

                          </div>
                          <div className={`flex p-4 px-5 items-center mt-4 border-t-[1px] ${isDark?' border-gray-700':'border-gray-200'}`}>
                              <button
                                type="button"
                                className={`inline-flex rounded-md  bg-transparent border  ${isDark?' border-slate-600 text-gray-400 hover:bg-slate-600':'border-gray-100 text-gray-600 hover:bg-gray-100'} px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 focus-visible:ring-offset-2`}
                                onClick={closeModal}
                              >
                                Close
                              </button>
                            </div>
                          
                        </motion.div>

                </AnimatePresence>
                  
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default SshInstanceModal